import { Flex, Modal, Typography } from "antd";
import { Registration } from "../interfaces/DevicesResult.interface";
import { Tag, TagValueType } from "../interfaces/Tag.interface";
import { versionCodeToString } from "../utils/versionCode.helper.utils";


const getTagLabelForKey = (key:string, tags:Tag[])=>{
    let tag = tags.find(x=>x.name == key);
    return tag?.label ?? key;
}
interface Group {
    title: string;
    labels: { key:string, label: string}[]
}

const renderTag = (value:string|number|boolean, tag: Tag|undefined):string => {
    if(tag)
    {
        if (tag.type == TagValueType.Enum_String) {
            let actualValue:string|number|boolean|undefined = value;
            if (actualValue && tag.meta.allowedValues && tag.meta.allowedValues.find(x => x.value == actualValue)) {
                actualValue = tag.meta.allowedValues.find(x => x.value == actualValue)?.label
            }
            return actualValue?.toString() ?? value.toString();
        } else if (tag.type == TagValueType.Number && tag.meta.isVersionCode && tag.meta.versionCodePadding) {
            let actualValue = value
            if(actualValue)
                return versionCodeToString(value as number, tag.meta.versionCodePadding);
            return actualValue?.toString() ?? value.toString()
        } else {
            let actualValue = value
            // let splitValue = actualValue.split(',');
            // if (splitValue.length > 1) {
            //     return splitValue.map(x => <Tag key={x}>{x}</Tag>)
            // }
            return actualValue?.toString() ?? value.toString()
        }
    }
    return value.toString();
}
export const DeviceDetail = (props: { applicationId:string, device:Registration, isOpen:boolean, tags: Tag[], onDismiss: ()=>void}) => {
    const groups:Group[] = [];

    let deviceTags = ["deviceId", "plt", "deviceOSVersionCode", "deviceType","modelNumber", "browserName", "browserVersion"]
    let locationTags = ["geoCountry", "geoState", "geoIP"]
    let mainGroup:Group = { title: "Device", labels: []};
    if(props.device.id)
        mainGroup.labels.push({key: "Id", label: props.device.id})

    for (let deviceTagIdx = 0; deviceTagIdx < deviceTags.length; deviceTagIdx++) {
        const deviceKey = deviceTags[deviceTagIdx];
        if(props.device.tags[deviceKey])
        {
            mainGroup.labels.push({key: deviceKey, label: renderTag(props.device.tags[deviceKey], props.tags.find(t=>t.name == deviceKey))})
        } 
    }
    
    let tags:Group = { title: "Tags", labels: []}
    tags.labels.push(
        ...Object.entries(props.device.tags).map(tag=>{ 
            return {key: tag[0], label: renderTag(props.device.tags[tag[0].toString()], props.tags.find(t=>t.name == tag[0].toString()))}
        }).filter(x=>!deviceTags.includes(x.key) && !locationTags.includes(x.key)).sort((a,b)=>a.key.localeCompare(b.key))
    );

    let geo:Group = { title: "Location", labels: []};
    geo.labels.push(
        ...Object.entries(props.device.tags).map(tag=>{ 
            return {key: tag[0], label: renderTag(props.device.tags[tag[0].toString()], props.tags.find(t=>t.name == tag[0].toString()))}
        }).filter(x=>locationTags.includes(x.key)).sort((a,b)=>a.key.localeCompare(b.key))
    );


    groups.push(...[mainGroup,geo, tags].filter(x=>x.labels.length > 0));
    
    return (
        <Modal
            open={props.isOpen}
            onOk={()=> props?.onDismiss()}
            onCancel={()=> props?.onDismiss()}
            okText="OK"
            cancelButtonProps={{ style: { display: 'none' } }}
            width={`99vw`}>
        
            <Flex vertical>
                {groups.map(g=>{
                    return (
                        <>
                        <Typography.Title level={3} key={g.title}>{g.title}</Typography.Title>
                        {g.labels.map(p=>(
                            <Typography.Paragraph key={p.key}><Typography.Text strong>{getTagLabelForKey(p.key, props.tags)}:</Typography.Text> <Typography.Text copyable>{p.label}</Typography.Text></Typography.Paragraph>
                        ))}
                        </>
                    )
                })}
            </Flex>
        </Modal>
    )
}